/*
 * *************************************
 * DO NOT MODIFY, FILE IS AUTO GENERATED
 * *************************************
 */

export interface LanguageOut {
    code: string;
    name: string;
    topLanguage: boolean;
}

export interface PerformerIn {
    biography?: string;
    country?: string;
    firstName?: string;
    lastName?: string;
    marcAuthorisedName?: string;
    website?: string;
}

export interface CountryOut {
    code: string;
    name: string;
    topCountry?: boolean;
}

export interface CreditRecordOut {
    cost?: number;
    creditAmount?: number;
    date?: number;
    id?: number;
}

export interface CreditSummaryOut {
    available?: number;
    creditRecordList?: Array<CreditRecordOut>;
    inUse?: number;
    total?: number;
}

export interface GenreCategoryOut {
    id?: string;
    name?: string;
}

export interface GenreListOut {
    genres?: Array<GenreOut>;
    mandatory: boolean;
}

export interface GenreDetailsOut {
    id: string;
    name: string;
    subGenres?: Array<SubGenreOut>;
    localGenre?: boolean;
    docCount?: number;
}

export interface GenresOut {
    localGenres: GenreListOut;
    standardGenres: GenreListOut;
}

export interface GenreOut {
    id: string;
    name: string;
}

export interface GenresDetailsListOut {
    localContentGenres?: Array<GenreDetailsOut>;
    standardGenres?: Array<GenreDetailsOut>;
}

export interface Level1Out {
    docCount?: number;
    id: string;
    level2?: Array<Level2Out>;
    name: string;
}

export interface Level2Out {
    docCount?: number;
    id: string;
    name: string;
}

export interface LibXchangeSharingOptions {
    countryCodes?: Array<string>;
    shareWorldwide?: boolean;
}

export interface LibraryCreatedProductOut {
    activeStatus?: Array<string>;
    ageCategory?: string;
    ageGroup?: string;
    alternativeId?: string;
    assetFileName?: string;
    authors?: Array<PerformerDetailsOut>;
    coverUrl?: string;
    defaultCover?: boolean;
    description?: string;
    enableMarcRecord?: boolean;
    explicit?: boolean;
    fiction?: boolean;
    genreCategory?: GenreCategoryOut;
    genres?: Array<GenreDetailsOut>;
    id?: string;
    isbn13?: string;
    keywords?: Array<string>;
    language?: string;
    languageCode?: string;
    libXchangeCountryCodes?: Array<string>;
    liveOnLibXchange?: boolean;
    loanFormat?: string;
    marcBiographicSubjects?: string;
    marcGenreHeadings?: string;
    marcGeographicSubjects?: string;
    marcSeries?: string;
    marcSubjectHeadings?: string;
    marcTitleWithoutPrefix?: string;
    pages?: number;
    productFormat?: ProductFormatEnum;
    productId?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number | string;
    seriesName?: string;
    seriesNumber?: number;
    shareOnLibXchange?: boolean;
    spocId?: string;
    spocName?: string;
    spocType?: string;
    subTitle?: string;
    teaser?: string;
    title?: string;
    titlePrefix?: string;
    titleWithoutPrefix?: string;
}

export interface LibraryCreatedProductRequest {
    ageCategory?: string;
    ageGroup?: string;
    alternativeId?: string;
    authorIds?: Array<number>;
    description?: string;
    enableMarcRecord?: boolean;
    explicit?: boolean;
    fiction?: boolean;
    genreCategoryId?: string;
    genreIds?: Array<string>;
    keywords?: Array<string>;
    languageCode?: string;
    marcBiographicSubjects?: string;
    marcGenreHeadings?: string;
    marcGeographicSubjects?: string;
    marcSeries?: string;
    marcSubjectHeadings?: string;
    marcTitleWithoutPrefix?: string;
    pages?: number;
    productFormat?: ProductFormatEnum;
    publisherImprint?: string;
    releaseDate?: string;
    seriesName?: string;
    seriesNumber?: number;
    subTitle?: string;
    title?: string;
    teaser?: string;
    titlePrefix?: string;
    titleWithoutPrefix?: string;
}

export enum ProductFormatEnum {
    PDF = 'PDF',
    EPUB = 'EPUB'
}

export interface MarketplaceProductOut {
    activeLibraries?: number;
    ageCategory?: string;
    ageGroup?: string;
    alreadyInCollection?: boolean;
    authors?: Array<PerformerOut>;
    copyAmount?: number;
    coverUrl?: string;
    genres?: Array<GenreDetailsOut>;
    isbn13?: string;
    language?: string;
    loanFormat?: string;
    pages?: number;
    productClass?: string;
    productFormat?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number;
    sampleUrl?: string;
    seriesName?: string;
    seriesNumber?: number;
    stockDetails?: { [key: string]: number };
    subTitle?: string;
    summary?: string;
    teaser?: string;
    termLimit?: number;
    title?: string;
    titleWithoutPrefix?: string;
    usageLimit?: number;
}

export interface MarketplaceProductsResponse {
    hits?: Array<MarketplaceProductOut>;
    totalHits?: number;
}

export interface PerformerDetailsOut {
    id: number;
    firstName?: string;
    lastName?: string;
    country?: string;
    website?: string;
    biography?: string;
    photoUrl?: string;
    productAmount?: number;
}

export interface PerformerOut {
    id?: string;
    name?: string;
}

export interface ProductOut {
    activeLibraries?: number;
    ageCategory?: string;
    ageGroup?: string;
    alreadyInCollection?: boolean;
    authors?: Array<PerformerOut>;
    copyAmount?: number;
    coverUrl?: string;
    explicit?: boolean;
    genres?: Array<GenreDetailsOut>;
    id?: string;
    illustrated?: boolean;
    isbn13?: string;
    language?: string;
    loanFormat?: string;
    pages?: number;
    productClass?: string;
    productFormat?: string;
    publisher?: string;
    publisherImprint?: string;
    releaseDate?: number;
    sampleUrl?: string;
    seriesName?: string;
    seriesNumber?: number;
    stockDetails?: { [key: string]: number };
    title?: string;
}

export interface PublishOptions {
    licenseAccepted?: boolean;
    licenseOption?: string;
    sharingOptions?: LibXchangeSharingOptions;
    targetSpoc?: string;
}

export interface SubGenreOut {
    id: string;
    name: string;
    docCount?: number;
}

export interface URL {
    authority?: string;
    content?: any;
    defaultPort?: number;
    deserializedFields?: {};
    file?: string;
    host?: string;
    path?: string;
    port?: number;
    protocol?: string;
    query?: string;
    ref?: string;
    serializedHashCode?: number;
    userInfo?: string;
}
